if (!customElements.get('three-columns-slideshow')) {
  customElements.define(
    'three-columns-slideshow',
    class ThreeColumnsSlideshow extends HTMLElement {
      constructor() {
        super();
        this.selectedIndex = Number(this.dataset.selectedIndex || 0);
        this.autoplayDelay = Number(this.dataset.autoplay || 0);
        this.mobileMediaQuery = window.matchMedia('(max-width: 767.98px)');
        this.touchStartX = null;
        this.touchStartY = null;
        this.timer = null;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.three-columns-slideshow__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-three-columns-slideshow-dot]'));
        this.prevButton = this.querySelector('[data-three-columns-slideshow-prev]');
        this.nextButton = this.querySelector('[data-three-columns-slideshow-next]');

        this.prevButton?.addEventListener('click', this.previous);
        this.nextButton?.addEventListener('click', this.next);
        this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
        this.addEventListener('mouseenter', this.stopAutoplay);
        this.addEventListener('mouseleave', this.startAutoplay);
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: false });
        this.addEventListener('touchcancel', this.resetTouch);

        this.select(this.selectedIndex, false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.prevButton?.removeEventListener('click', this.previous);
        this.nextButton?.removeEventListener('click', this.next);
        this.dots?.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
        this.removeEventListener('mouseenter', this.stopAutoplay);
        this.removeEventListener('mouseleave', this.startAutoplay);
        this.removeEventListener('touchstart', this.onTouchStart);
        this.removeEventListener('touchend', this.onTouchEnd);
        this.removeEventListener('touchcancel', this.resetTouch);
        this.stopAutoplay();
      }

      onTouchStart = (event) => {
        if (!this.mobileMediaQuery.matches || event.touches.length !== 1) {
          this.resetTouch();
          return;
        }

        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
      };

      onTouchEnd = (event) => {
        if (this.touchStartX === null || this.touchStartY === null || !this.mobileMediaQuery.matches) {
          this.resetTouch();
          return;
        }

        const touch = event.changedTouches[0];
        const distanceX = touch.clientX - this.touchStartX;
        const distanceY = touch.clientY - this.touchStartY;
        this.resetTouch();

        if (Math.abs(distanceX) < 50 || Math.abs(distanceX) <= Math.abs(distanceY) * 1.25) return;

        event.preventDefault();
        if (distanceX < 0) this.next();
        else this.previous();
      };

      resetTouch = () => {
        this.touchStartX = null;
        this.touchStartY = null;
      };

      previous = () => {
        this.select(this.selectedIndex - 1);
      };

      next = () => {
        this.select(this.selectedIndex + 1);
      };

      onDotClick = (event) => {
        this.select(Number(event.currentTarget.dataset.threeColumnsSlideshowDot || 0));
      };

      select(index, restart = true) {
        if (!this.slides.length) return;

        const nextIndex = (index + this.slides.length) % this.slides.length;
        this.selectedIndex = nextIndex;
        this.dataset.selectedIndex = String(nextIndex);

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === nextIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === nextIndex);
        });

        if (restart) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      startAutoplay = () => {
        if (!this.autoplayDelay || this.slides.length < 2 || this.timer) return;
        this.timer = window.setInterval(() => this.next(), this.autoplayDelay);
      };

      stopAutoplay = () => {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      };
    }
  );
}
